import { render, staticRenderFns } from "./InvoiceSubtotal.vue?vue&type=template&id=05b05db2&scoped=true&"
import script from "./InvoiceSubtotal.vue?vue&type=script&lang=js&"
export * from "./InvoiceSubtotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b05db2",
  null
  
)

export default component.exports